export * from "modules/TyresDashboard/components/TyreModal/components/TyreForm";
